import React from 'react';
import InputTitleView from './InputTitleView';

const TextareaInputView = ({ title = '', required = false, subTitle = '', name, value, onChange, placeholder, limit }) => {
  return (
    <div className="recruitment-textarea-input-view">
      <InputTitleView title={title} required={required} subTitle={subTitle} />
      <div className="recruitment-textarea-input-view-input-wrapper">
        <textarea name={name} placeholder={placeholder} value={value} onChange={({ target }) => onChange({ name: target.name, value: target.value })} />
        <div className="limit">{`${value.length}/${limit}`}</div>
      </div>
    </div>
  );
};

export default TextareaInputView;
